<template>
  <SfIconBase
    v-if="iconImage"
    :icon="iconImage.paths"
    :view-box="iconImage.viewBox"
    :size="size"
    v-bind="$attrs"
  >
    <path
      v-for="path in iconImage.paths"
      :key="path"
      :d="path"
      fill-rule="evenodd"
    />
  </SfIconBase>
</template>

<script lang="ts" setup>
import { SfIconBase } from '@storefront-ui/vue';

import { icons } from '~/components/assets/icons';

interface Props {
  icon: keyof typeof icons;
  size?: 'sm' | 'base' | 'lg' | 'xs' | 'xl' | '2xl' | '3xl' | '4xl' | undefined;
  color?: string;
}

defineEmits(['click', 'mouseover', 'mouseleave']);

const props = withDefaults(defineProps<Props>(), {
  size: 'base',
});

const iconImage = computed(() => icons[props.icon]);
</script>
